import { createContext } from 'react';

const ReferralsTableContext = createContext();

export default ReferralsTableContext;
